export default __webpack_public_path__ + "static/media/logo.a6f66bb8.png";